module.exports = __webpack_public_path__ + "img/submit-bg.04c4053.png";